import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalise an internal route to canonical trailing-slash form.
 *
 * The server (Cloudflare Pages) 301-redirects every slash-less path to its
 * trailing-slash variant. Linking to the slash-less form makes Googlebot crawl
 * a redirect hop, which surfaces as the "Pagina met omleiding" indexing error.
 * Always pass internal hrefs through this helper so links resolve directly.
 *
 * Leaves "/" untouched, and skips hashes, query-only links, external URLs
 * (http/mailto/tel) and paths that already end in "/" or a file extension.
 *
 * @param {string} path  Internal route, e.g. "/fleet-management"
 * @returns {string}     Trailing-slash form, e.g. "/fleet-management/"
 */
export function internalLink(path) {
  if (typeof path !== "string" || path === "" || path === "/") return path || "/";
  // External / non-route links: leave as-is.
  if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path;
  // Split off any hash / query so we slash the path part only.
  const [base, ...rest] = path.split(/(?=[?#])/);
  const suffix = rest.join("");
  if (base.endsWith("/")) return path;
  // Skip files with an extension (e.g. /file.pdf).
  if (/\.[a-z0-9]+$/i.test(base)) return path;
  return `${base}/${suffix}`;
}
